import React, { useState, useContext } from "react"; // Make sure useState and useEffect are imported from React
import { ProductContext } from '../../../../pages/ProductStencil';
import { BenefitLabel } from "../../common/BenefitLabel";
import { isEcommerceEnabled } from "../../../../../selectors/generic";
import { pdpGA4ViewPromotion } from "../../../../../analytics/ga4/events/gaEventsPDP";
import { GetBasketItem } from "../../../../../interfaces/ecom/schema";

const PromoBadge = ({ PromoCode }: { PromoCode: string }) => <span className="pdp-badge pdp-badge--promo p-text-color-white p-bg-red">{PromoCode}</span>;

export const OverviewBadge = () => {
    const { activeProductIndex, Packaging, SapDetails, product } = useContext(ProductContext);
    const { benefits } = product.tags;
    const [basket] = useState<GetBasketItem[]>([]);
    let PromoCode;
    
    if (isEcommerceEnabled() && !SapDetails?.[0]?.IsObsolete) {
        PromoCode = Packaging?.[activeProductIndex]?.Promotions?.[0]?.PromoCode ?? null;
    }

    if (PromoCode && isEcommerceEnabled() && !SapDetails?.[0]?.IsObsolete) {
        const itemBasketQuantity = basket.find(item => item.MaterialNumber === Packaging[activeProductIndex].MaterialNumber)?.Quantity || 0;

        pdpGA4ViewPromotion(
            Packaging[activeProductIndex],
            itemBasketQuantity
        );
    }

    return (
        <div className="pdp__badges-container">
            {!!PromoCode ? (
                <>
                    <PromoBadge PromoCode={PromoCode} />
                    {benefits.length > 0 && <BenefitLabel benefit={benefits[0]} />}
                </>
            ) : (
                benefits.length > 0 &&
                benefits.slice(0, 2).map((benefit, index) => <BenefitLabel benefit={benefit} key={index} />)
            )}
        </div>
    );
};
